import RewardsFormInput from './RewardsFormInput';
export default RewardsFormInput;
